import { userUserStore } from "../stores/user";
import { useUsuarioRolesStore } from "../services/usuarioRoles";
import { Permisos } from "@fixeduy/restaurantestypes";

/**
 * Admin: accede a todo sin restricciones (array permisos vacío).
 * No-admin: solo accede si el permiso está en rol.permisos.
 */
export const puedeAccederModulo = (permiso: Permisos): boolean => {
  const userStore = userUserStore();
  const usuarioRolesStore = useUsuarioRolesStore();

  if (!userStore.usuario?.rolId) return false;

  const rol = usuarioRolesStore.getRolById(userStore.usuario.rolId);
  if (!rol) return false;

  // Admin: array vacío = acceso total
  if (rol.rol === "Admin") return true;

  return rol.permisos?.includes(permiso) ?? false;
};

/**
 * Usado para acciones granulares (crear, listar, exportar, etc.).
 * Mantiene compatibilidad con token.claims si existen.
 */
export const permisos = (permiso: Permisos): boolean => {
  const userStore = userUserStore();

  // Admin vía claims (Firebase Auth)
  if (userStore.token?.claims["rol"] === "Admin") return true;

  // Admin vía rol en usuarios-roles
  const usuarioRolesStore = useUsuarioRolesStore();
  const rol = userStore.usuario?.rolId
    ? usuarioRolesStore.getRolById(userStore.usuario.rolId)
    : null;
  if (rol?.rol === "Admin") return true;

  // Permisos desde claims (string separado por coma)
  const rawPermisos = userStore.token?.claims["permisos"];
  const permisosClaims: string | null =
    typeof rawPermisos === "string" ? rawPermisos : null;
  if (permisosClaims?.split(",")?.includes(permiso)) return true;

  // Permisos desde rol en Firestore
  if (rol?.permisos?.includes(permiso)) return true;

  return false;
};

export const isAdmin = (): boolean => {
  const userStore = userUserStore();

  if (userStore.token?.claims["rol"] === "Admin") return true;

  const usuarioRolesStore = useUsuarioRolesStore();
  const rol = userStore.usuario?.rolId
    ? usuarioRolesStore.getRolById(userStore.usuario.rolId)
    : null;

  return rol?.rol === "Admin" || false;
};

export const puedeVerLogAccionesInterno = (): boolean => {
  const userStore = userUserStore();
  const mail = (userStore.usuario?.mail ?? userStore.user?.email ?? "")
    .trim()
    .toLowerCase();
  return mail.endsWith("@fixed.uy") || mail.endsWith("@atiendo.cloud");
};
